import styled from 'styled-components';

export const TimelineContainer = styled.div`
  
  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 10px;
  }
  
  th {
    background-color: #f8f9fa;
    padding: 15px 20px;
    text-align: left;
    font-weight: 600;
    border-bottom: 2px solid #dee2e6;
    font-size: 14px;
    color: #495057;
  }
  
  td {
    padding: 15px 20px;
    border-bottom: 1px solid #e9ecef;
    vertical-align: middle;
  }
  
  tr:hover {
    background-color: #f8f9fa;
  }
  
  h4 {
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
`;

export const TimelineItem = styled.li`
  position: relative;
  margin-bottom: 20px;
  padding-left: 10px;

  div {
    padding: 5px 10px;
    background: #f9f9f9;
    border-radius: 5px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
`;

export const TimelinePoint = styled.span`
  position: absolute;
  left: -8px;
  top: 8px;
  width: 12px;
  height: 12px;
  background: #2f2f2f;
  border-radius: 50%;
  border: 2px solid #fff;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
`;

export const ConsultationList = styled.div`
margin-top: 10px;
padding: 10px;
background: #f8f9fa;
border: 1px solid #dee2e6;
border-radius: 5px;

h5 {
  margin-bottom: 10px;
  }
  
  div {
    margin-bottom: 8px;
    }
    `;


export const DetailButton = styled.button`
      padding: 5px 10px;
      background-color: #2f2f2f;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
      font-size: 14px;
    
      &:hover {
        background-color: #1a1a1a;
      }
    `;

export const EntregaButton = styled.button`
  padding: 5px 10px;
  background-color: #595959;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #404040;
  }
`;

export const RestaurarGravidezButton = styled.button`
  padding: 10px;
  background-color:#8a8a8a;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color:#6c757d;
  }
`


export const EncerrarGravidezButton = styled.button`
  padding: 10px;
  background-color:#1a1a1a;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color:#1a1a1a;
  }
`

export const EditarGravidezButton = styled.button`
  padding: 10px;
  background-color:rgba(138, 138, 138, 1);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: rgba(108, 117, 125, 1);
  }
`

export const EditarConsultaButton = styled.button`
  padding: 10px;
  background-color:rgba(138, 138, 138, 1);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: rgba(108, 117, 125, 1);
  }
`

export const ActionsMenuContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const MenuButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  font-size: 20px;
  color: #495057;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const MenuDropdown = styled.div`
  position: absolute;
  right: 18px;
  bottom: 10px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 1000;
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 15px;
  border: none;
  background: white;
  text-align: left;
  cursor: pointer;
  font-size: 12px;
  color: #333;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f0f0f0;

  &:first-child {
    border-radius: 4px 4px 0 0;
  }

  &:last-child {
    border-bottom: none;
    border-radius: 0 0 4px 4px;
  }

  &:hover {
    background-color: #f8f9fa;
  }

  &.primary {
    color: #2f2f2f;
  }

  &.success {
    color: #595959;
  }

  &.warning {
    color: #8a8a8a;
  }

  &.info {
    color: #6c757d;
  }

  &.danger {
    color: #1a1a1a;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
    background: #f8f9fa;
    color: #999;
  }

  &:disabled:hover {
    background-color: #f8f9fa;
  }
  
  svg {
    flex-shrink: 0;
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  
  &.em-andamento {
    background-color: #2f2f2f;
    color: white;
  }
  
  &.encerrada {
    background-color: #6c757d;
    color: white;
  }
  
  &.interrompida {
    background-color: #1a1a1a;
    color: white;
  }
`;

export const KitStatusBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  
  &.entregue {
    background-color: #595959;
    color: white;
  }
  
  &.nao-entregue {
    background-color: #8a8a8a;
    color: #333;
  }
  
  &.pendente {
    background-color: #1a1a1a;
    color: white;
  }
`;

export const ConsultasTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 10px;
  
  thead {
    tr {
      background-color: #f8f9fa;
      
      th {
        padding: 12px 15px;
        text-align: left;
        font-weight: 600;
        border-bottom: 2px solid #dee2e6;
        font-size: 14px;
        color: #495057;
      }
    }
  }
  
  tbody {
    tr {
      border-bottom: 1px solid #e9ecef;
      transition: background-color 0.2s;
      
      &:hover {
        background-color: #f8f9fa;
      }
      
      td {
        padding: 12px 15px;
        vertical-align: middle;
        font-size: 14px;
        color: #333;
      }
    }
  }
`;

export const ConsultaActionButton = styled.button`
  background-color: #8a8a8a;
  color: #333;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  
  &:hover {
    background-color: #6c757d;
  }
`;